import { PaletteMode, PaletteOptions } from '@mui/material';
import { green, grey, red } from '@mui/material/colors';
import { THEMEMODE } from '_constants';

const colors = {
  purple: '#5e60c1',
  darkPurple: '#562fa3',
  lightPurple: '#aa96d0',
  white: '#ffffff',
};

const colorPalette = {
  green: {
    main: green[600],
    darker: green[900],
  },
  grey: {
    main: grey[300],
    light: grey[100],
    dark: grey[500],
    darker: grey[700],
  },
  red: {
    main: red[600],
    dark: red[900],
  },
};

export const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,
    ...(mode === THEMEMODE.light
      ? {
          ...colorPalette,
          primary: {
            main: colors.purple,
            light: colors.lightPurple,
            dark: colors.darkPurple,
          },
          text: {
            primary: grey[900],
            secondary: '#767676',
            black: 'black',
          },
        }
      : {
          ...colorPalette,
          primary: {
            main: colors.purple,
            light: colors.lightPurple,
            dark: colors.darkPurple,
          },
          background: {
            default: grey[900],
            paper: grey[800],
          },
          table: {
            default: grey[900],
          },
          text: {
            primary: colors.white,
            secondary: grey[500],
          },
        }),
  } as PaletteOptions,
  spacing: 2,
});
